export default __webpack_public_path__ + "static/media/GridNoProductImage.238bdeff.jpg";